import { lazy } from 'react';

export const patients = lazy(() => import('./patients'));
